import { useTranslation } from 'react-i18n-lite'
import { Button, Icon, LinkButton } from '@yes.technology/react-toolkit'

import GenericObjectCardButton from 'component/GenericObjectCard/GenericObjectCardButton'
import { useLocation } from 'react-router'

import { TaskActionsContainer, TaskActionsRow } from './TaskObjectCard.styles'
import { TaskActionsProps } from './TaskObjectCard.types'

const TaskActions = ({
  statusUuid,
  taskUuid,
  statusActions,
  primaryStatusActionUuid,
  changeStatus,
  objectclassUuid,
  returnOnFinish = false,
  buttonProps
}: TaskActionsProps) => {
  const { t } = useTranslation()
  const location = useLocation()
  const relativeEncodedUrl = encodeURIComponent(
    location.pathname + location.search + location.hash
  )
  const executeHref = `/${window.taskExecutorSitemodelUuid}?taskUuid=${taskUuid}&returnUrl=${relativeEncodedUrl}&returnOnFinish=${returnOnFinish.toString()}`

  const isWaitingInteraction =
    window.waitingInteractionStatusUuid === statusUuid

  const validStatusActions = statusActions.filter(
    (statusAction) => statusAction.destination_status?.[0]
  )

  const sortedValidStatusActions = [
    ...validStatusActions.filter(
      (statusAction) => statusAction.uuid === primaryStatusActionUuid
    ),
    ...validStatusActions.filter(
      (statusAction) => statusAction.uuid !== primaryStatusActionUuid
    )
  ]

  const visualizeButton = (
    <LinkButton
      key='view'
      variant='secondary'
      heightClass='small'
      style={{ width: '24px', minWidth: '24px' }}
      aria-label={t('task.action.view')}
      href={`/${window.objectDetailsSitemodelUuid}?uuid_objectclass=${objectclassUuid}&object-uuid=${taskUuid}`}
    >
      <Icon iconName='Visualization' icSize='small' />
    </LinkButton>
  )

  const executeButton =
    buttonProps !== undefined ? (
      <GenericObjectCardButton
        buttonProps={buttonProps}
        href={executeHref}
        label={t('task.action.execute')}
        variant='primary'
      />
    ) : (
      <LinkButton
        rel='noopener noreferrer'
        variant='primary'
        heightClass='small'
        href={executeHref}
      >
        {t('task.action.execute')}
      </LinkButton>
    )

  return (
    <TaskActionsContainer>
      {isWaitingInteraction && (
        <TaskActionsRow>
          {executeButton}
          {!validStatusActions.length && visualizeButton}
        </TaskActionsRow>
      )}
      {sortedValidStatusActions.map((statusAction, i) => (
        <TaskActionsRow key={`${statusAction.destination_status[0].code}_${i}`}>
          <Button
            variant={
              !isWaitingInteraction &&
              statusAction.uuid === primaryStatusActionUuid
                ? 'primary'
                : 'secondary'
            }
            heightClass='small'
            onClick={() =>
              changeStatus(statusAction.destination_status[0].code)
            }
          >
            {statusAction.des}
          </Button>
          {i === sortedValidStatusActions.length - 1 && visualizeButton}
        </TaskActionsRow>
      ))}
    </TaskActionsContainer>
  )
}

export default TaskActions
